import { useContext } from "react"
import { useTranslation } from "react-i18next"
import { AuthContext } from "../../controllers/auth"
import Center from "../../components/global/Center"
import Text from "../../components/global/Text"
import Button from "../../components/global/Button"
import PlatformLogo from "../../components/global/PlatformLogo"

const NoTeam = () => {
  const { t } = useTranslation()
  const { logOut } = useContext(AuthContext)

  return (
    <Center>
      <PlatformLogo
        containerStyle={{ width: "fit-content" }}
        textStyle={{ maxWidth: 200 }}
      />
      <Text textAlign="center" style={{ marginTop: 42 }}>
        {t("no_teams")}
      </Text>
      <Button onClick={logOut} style={{ width: 100, marginTop: 24 }}>
        {t("logout")}
      </Button>
    </Center>
  )
}

export default NoTeam
